/**
 * Dokumentations-Service für integrierte Hilfe
 */

import axios from "axios"

const API_URL = import.meta.env.VITE_API_URL || "/api/v1"

export interface DocInfo {
  id: string
  title: string
  description: string
  category: string
  available: boolean
}

export interface DocContent extends DocInfo {
  content: string
  filename: string
}

export interface DocsListResponse {
  documents: DocInfo[]
  categories: Record<string, DocInfo[]>
  totalCount: number
}

/**
 * Lädt die Liste aller verfügbaren Dokumentationen
 */
export async function listDocs(): Promise<DocsListResponse> {
  const response = await axios.get<DocsListResponse>(`${API_URL}/docs`)
  return response.data
}

/**
 * Lädt eine spezifische Dokumentation
 */
export async function getDoc(docId: string): Promise<DocContent> {
  const response = await axios.get<DocContent>(`${API_URL}/docs/${docId}`)
  return response.data
}
